import { TdHTMLAttributes } from "react";
import { Container, Content, Message, Hint } from "./styles";

interface NoProductResultProps extends TdHTMLAttributes<HTMLTableCellElement> {
  colSpan?: number;
}

const NoProductResult = ({ colSpan, ...rest }: NoProductResultProps) => (
  <Container>
    <td colSpan={colSpan} {...rest}>
      <Content>
        <Message>Nenhum produto encontrado</Message>
        <Hint>Tente ajustar os filtros ou buscar por outro termo</Hint>
      </Content>
    </td>
  </Container>
);

export default NoProductResult;
